// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleContent_root__3QHPz"};